import { render, staticRenderFns } from "./list.vue?vue&type=template&id=47d47002&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d47002",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d47002')) {
      api.createRecord('47d47002', component.options)
    } else {
      api.reload('47d47002', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=47d47002&scoped=true", function () {
      api.rerender('47d47002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/refundTicket/list.vue"
export default component.exports